__sknnlv_webpackJsonp__([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_Whatsub__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_LanguageSwitcherController__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_ProductTabsController__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_product_Module__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_AccountController__ = __webpack_require__(14);






window.addEventListener('load', function () {
  window.WhatSub = {
    subscribe: __WEBPACK_IMPORTED_MODULE_0__modules_Whatsub__["b" /* subscribe */],
    dispatch: __WEBPACK_IMPORTED_MODULE_0__modules_Whatsub__["a" /* dispatch */],
    unsubscribe: __WEBPACK_IMPORTED_MODULE_0__modules_Whatsub__["c" /* unsubscribe */]
  };

  Object(__WEBPACK_IMPORTED_MODULE_1__controllers_LanguageSwitcherController__["a" /* LanguageSwitcherController */])();
  Object(__WEBPACK_IMPORTED_MODULE_2__controllers_ProductTabsController__["a" /* ProductTabsController */])();
  Object(__WEBPACK_IMPORTED_MODULE_4__controllers_AccountController__["a" /* default */])();

  Object(__WEBPACK_IMPORTED_MODULE_3__modules_product_Module__["a" /* default */])();
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unsubscribe; });
/* unused harmony export getSubscribers */
/* unused harmony export getSubscribersByEvent */
/**
 * The WhatSub methods keep track of subscriptions to events
 * Users can create subscriptions using the `subscribe` function
 * By using `dispatch`, an event can be triggered and all subscription callbacks will be triggered
 * Lastly, you can remove a subscription from the list by using the `unsubscribe` function
 *
 * @example
 * subscribe('TEST_EVENT', testFn);
 * dispatch('TEST_EVENT', ['something', 'else']);
 * unsubscribe('TEST_EVENT', testFn);
 */

var subscribers = {};
function WhatsSub() {}

/**
 * Subscribe to a new event
 * @param {String} event
 * @param {Function} callback
 * @param {int} priority
 *
 * @return {void}
 */
var subscribe = function subscribe(event, callback) {
    var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (!subscribers[event]) {
        subscribers[event] = [];
    }

    subscribers[event].push({
        callback: callback,
        priority: priority
    });
};

/**
 * Trigger all required actions based on an event
 * @param {String} event
 * @param {Object} target
 *
 * @return {void}
 */
var dispatch = function dispatch(event, target) {
    var targets = target;
    if (!Array.isArray(target)) {
        targets = [target];
    }

    if (subscribers[event]) {
        subscribers[event].forEach(function (subscriber) {
            subscriber.callback.apply(null, targets);
        });
    }
};

/**
 * Unsubscribe from an event
 * @param {String} event
 * @param {Function} callback
 *
 * @return {void}
 */
var unsubscribe = function unsubscribe(event, callback) {
    if (subscribers[event]) {
        subscribers[event] = subscribers[event].filter(function (subscriber) {
            return subscriber.callback !== callback;
        });
    }
};

/**
 * Show a list of all the subscriptions
 *
 * @return {Object}
 */
var getSubscribers = function getSubscribers() {
    return subscribers;
};

/**
 * Show of a list of all the subscriptions by event
 *
 * @param {String} event
 *
 * @return {Object}
 */
var getSubscribersByEvent = function getSubscribersByEvent(event) {
    return subscribers[event];
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageSwitcherController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Utils_js__ = __webpack_require__(6);


var LanguageSwitcherController = function LanguageSwitcherController() {
    $('.m-localization-header .disclosure__toggle').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).next().toggleClass('disclosure-list--visible');
    });

    $('.m-localization-header .disclosure-list__item').on('click', function (e) {
        var value = $(e.currentTarget).data('value');

        if (value) {
            e.preventDefault();
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_Utils_js__["a" /* triggerEvent */])(document.querySelector('#localization_form .disclosure-list__item[data-value="' + value + '"]'), 'click');
        }
    });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return triggerEvent; });
// no-jquery version of trigger
var triggerEvent = function triggerEvent(el, type) {
    if ('createEvent' in document) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    } else {
        var e = document.createEventObject();
        e.eventType = type;
        el.fireEvent('on' + e.eventType, e);
    }
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(enquire, $) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTabsController; });
var ProductTabsController = function ProductTabsController() {

  enquire.register("screen and (max-width: 720px)", {
    match: function match() {
      $('.js-tab-flyout.active').removeClass('active');
      $('.js-tab-toggle.active').removeClass('active');
      $('.m-tab-content.active').removeClass('active');

      $('.js-tab-flyout').first().addClass('active');
      $('.js-tab-toggle').first().addClass('active');
      $('.m-tab-content').first().addClass('active');
    },
    unmatch: function unmatch() {
      $('.js-tab-flyout.active').removeClass('active');
      $('.js-tab-toggle.active').removeClass('active');
      $('.m-tab-content.active').removeClass('active');

      $('.js-tab-flyout').first().addClass('active');
      $('.js-tab-toggle').first().addClass('active');
      $('.m-tab-content').first().addClass('active');
    }
  });

  $('.js-tab-toggle').on('click', function (e) {
    e.preventDefault();
    var currentTarget = e.currentTarget;
    var target = $(currentTarget).data('target');

    $('.js-tab-toggle.active').removeClass('active');
    $('.m-tab-content.active').removeClass('active');

    $(currentTarget).addClass('active');
    $(target).addClass('active');
  });

  $('.js-tab-flyout').on('click', function (e) {
    e.preventDefault();
    var currentTarget = e.currentTarget;
    var target = $(currentTarget).data('target');

    $(currentTarget).toggleClass('active');
    $(target).toggleClass('active');
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_VariantPriceController__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_LoginButtonController__ = __webpack_require__(13);



/**
 * Constructor for the product module
 *
 * @return {void}
 */
var init = function init() {
  Object(__WEBPACK_IMPORTED_MODULE_0__controllers_VariantPriceController__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_1__controllers_LoginButtonController__["a" /* default */])();
};

/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Update price
 *
 * @return {void}
 */
var updatePrice = function updatePrice() {
  var currentProduct = window.CURRENT_PRODUCT;
  var currentPrice = window.CURRENT_PRICE;

  var compareAtPriceField = window.COMPARE_AT_PRICE_FIELD;
  var priceField = window.PRICE_FIELD;

  var percentage = false;
  var priceUpdated = false;

  for (var i = 0; i < currentProduct.tags.length; i++) {
    if (currentProduct.tags[i].includes("Korting_")) {
      var tag = currentProduct.tags[i].slice(8);
      percentage = parseInt(tag);
      break;
    }
  }

  if (percentage) {
    var priceInt = currentPrice.slice(1).replace(",", ".");
    priceInt = parseFloat(priceInt);

    var priceDiff = priceInt / 100 * percentage;
    priceUpdated = priceInt - priceDiff;
    priceUpdated = roundDecimals(priceUpdated, 2).toFixed(2);

    var priceFormatted = priceUpdated.toString().replace(".", ",");

    // $("[data-price-compare-at] .money").html(currentPrice);
    // $("[data-price] .money").html(`&euro;${priceFormatted}`);
    compareAtPriceField.html(currentPrice);
    priceField.html("&euro;" + priceFormatted);
  }
};

var addDecimal = function addDecimal(number) {
  return Number((number / 100).toFixed(2));
};

var roundDecimals = function roundDecimals(number, decimals) {
  return Number(Math.round(number + "e" + decimals) + "e-" + decimals);
};

/**
 * VaeiantPriceController
 *
 * @return {void}
 */
var VariantPriceController = function VariantPriceController() {
  window.WhatSub.subscribe("PRICE_UPDATE", updatePrice);
};

/* harmony default export */ __webpack_exports__["a"] = (VariantPriceController);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Update button
 *
 * @return {void}
 */
var updateButton = function updateButton() {
  //  const form = $('.modal-content form[data-product-form]');

  if (window.CUSTOMER) {
    $('.modal-content form[data-login-button="true"] .slideshow-button').addClass('hide');
    $('.modal-content form[data-login-button="true"] .product-form--atc').removeClass('hide');
  } else {
    $('.modal-content form[data-login-button="true"] .slideshow-button').removeClass('hide');
    $('.modal-content form[data-login-button="true"] .product-form--atc').addClass('hide');
  }
};

/**
 * LoginButtonController
 *
 * @return {void}
 */
var LoginButtonController = function LoginButtonController() {
  window.WhatSub.subscribe("LOGIN_BUTTON", updateButton);
};

/* harmony default export */ __webpack_exports__["a"] = (LoginButtonController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * AccountController
 *
 * @return {void}
 */
var AccountController = function AccountController() {
  if ($('.js-order-history-toggle').length > 0) {
    if (window.location.href.indexOf('page=') !== -1) {
      $('.js-order-history').addClass('show');
    }
    $('.js-order-history-toggle').on('click', function (e) {
      e.preventDefault();
      $('.js-order-history').addClass('show');
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AccountController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ })
],[3]);


// WEBPACK FOOTER //
// app.bundle.js